// app.config.ts
export default defineAppConfig({
  ui: {
    modal: {
      slots: {
        footer: 'justify-end',
      },
      variants: {
        overlay: {
          true: {
            overlay: 'bg-black/50',
          },
        },
      },
    },
    formField: {
      slots: {
        error: 'mt-0.5',
      },
    },
    container: {
      base: 'w-full max-w-(--ui-container) mx-auto lg:px-0',
    },
    colors: {
      primary: 'sky',
    },
    dashboardSidebar: {
      slots: {
        root: 'bg-primary-900 dark:bg-primary-400',
        body: 'px-0',
      },
    },
    dashboardPanel: {
      slots: {
        body: 'bg-gray-50',
      },
    },
    button: {
      slots: {
        base: 'cursor-pointer',
      },
    },
    radioGroup: {
      variants: {
        size: {
          sm: {
            item: 'text-xs w-full',
            base: 'size-3.5',
          },
        },
      },
      compoundVariants: [
        {
          size: 'sm',
          variant: ['card', 'table'],
          class: {
            item: 'p-[5px]',
          },
        },
      ],
    },
    checkbox: {
      variants: {
        size: {
          sm: {
            wrapper: 'text-xs',
            base: 'size-3.5',
          },
        },
      },
      compoundVariants: [
        {
          size: 'sm',
          variant: 'card',
          class: {
            root: 'p-[5px]',
          },
        },
      ],
    },
    select: {
      compoundVariants: [
        {
          color: 'primary',
          variant: ['outline', 'subtle'],
          class: 'focus:ring-1 focus:ring-inset focus:ring-primary',
        },
      ],
    },
    dashboardNavbar: {
      slots: {
        root: 'text-[14px] uppercase h-14',
        icon: 'size-4',
      },
    },
  },
})
